export class ForgotPasswordModel {
  username: string;
  verificationCode: string;
  password: string;
  isSuccess: boolean;
  isRequiredSecondStep: boolean;
  message: string;
}
